import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink, Guid } from "@/types"


export enum CalculationAdjustmentType {
    revenue = "revenue",
    sdc = "sdc",
    acquisitionCosts = "acquisitionCosts"
}

export enum RevenueCalculationAdjustmentCategory {
    underestimatedRepurchasedMachines = "underestimatedRepurchasedMachines",
    other = "other"

}

export enum SdcCalculationAdjustmentCategory {
    freight = "freight",
    mounting = "mounting",
    cashDiscounts = "cashDiscounts",
    purchaseFunding = "purchaseFunding",
    overestimatedRepurchasedMachines = "overestimatedRepurchasedMachines",
    provision = "provision",
    maintenance = "maintenance",
    other = "other"

}

export enum AcquisitionCostsCalculationAdjustmentCategory {
    additionalAcquisition = "additionalAcquisition",
    purchasingCostsFreight = "purchasingCostsFreight",
    other = "other"
}

export type CalculationAdjustmentCategory = RevenueCalculationAdjustmentCategory | SdcCalculationAdjustmentCategory | AcquisitionCostsCalculationAdjustmentCategory

export interface IGetCalculationAdjustmentDto {
    id: Guid
    isAutomatic?:boolean
    type: CalculationAdjustmentType
    category: CalculationAdjustmentCategory
    amount: number
    comment?: string | null
    links?: IApiLink[]
}

export interface IPostCalculationAdjustmentDto {
    type: CalculationAdjustmentType
    category: CalculationAdjustmentCategory
    amount: number
    comment?: string | null
}

export interface IPatchCalculationAdjustmentDto{
    amount: number,
    comment?: string | null
}

export interface IDraftCalculationAdjustmentDto extends Omit<IPostCalculationAdjustmentDto, "amount"> {
    id: number
    amount?: number
}

export default class CalculationAdjustment {
    id: Guid
    isAutomatic?:boolean
    type: CalculationAdjustmentType
    category: CalculationAdjustmentCategory
    amount: number
    comment?: string | null
    linkUpdate?: IApiLink
    linkDelete?: IApiLink

    constructor(dto: IGetCalculationAdjustmentDto) {
        this.id = dto.id
        this.isAutomatic = dto.isAutomatic
        this.type = dto.type
        this.category = dto.category
        this.amount = dto.amount
        this.comment = dto.comment
        this.linkUpdate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.calculationAdjustment && lnk.rel === ApiLinkRel.update)
        this.linkDelete = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.calculationAdjustment && lnk.rel === ApiLinkRel.delete)

    }

    toPostDto() {
        return {
            type: this.type,
            category: this.category,
            amount: this.amount,
            comment: this.comment
        }
    }
}
